var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8YoutubeLive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "32px",
    height: "32px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10156,6.10156c-2.534,2.533 -4.10156,6.03244 -4.10156,9.89844c0,3.866 1.56756,7.36544 4.10156,9.89844l1.41797,-1.41797c-2.173,-2.173 -3.51953,-5.17247 -3.51953,-8.48047c0,-3.308 1.34653,-6.30747 3.51953,-8.48047zM25.89844,6.10156l-1.41797,1.41797c2.173,2.173 3.51953,5.17247 3.51953,8.48047c0,3.308 -1.34653,6.30747 -3.51953,8.48047l1.41797,1.41797c2.534,-2.533 4.10156,-6.03244 4.10156,-9.89844c0,-3.866 -1.56756,-7.36544 -4.10156,-9.89844zM9.63672,9.63672c-1.629,1.629 -2.63672,3.87828 -2.63672,6.36328c0,2.485 1.00772,4.73428 2.63672,6.36328l1.41602,-1.41602c-1.268,-1.267 -2.05273,-3.01727 -2.05273,-4.94727c0,-1.93 0.78473,-3.68027 2.05273,-4.94727zM22.36328,9.63672l-1.41602,1.41602c1.268,1.267 2.05273,3.01727 2.05273,4.94727c0,1.93 -0.78473,3.68027 -2.05273,4.94727l1.41602,1.41602c1.629,-1.629 2.63672,-3.87828 2.63672,-6.36328c0,-2.485 -1.00772,-4.73428 -2.63672,-6.36328zM16,12c-2.20914,0 -4,1.79086 -4,4c0,2.20914 1.79086,4 4,4c2.20914,0 4,-1.79086 4,-4c0,-2.20914 -1.79086,-4 -4,-4z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#ff2626",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.55,172.25v37.97h19.9v7.53h-29.28v-45.5zM109.8,172.25v45.5h-9.38v-45.5zM125.05,172.25l10.25,34.22l10.31,-34.22h10.44l-15.85,45.5h-9.78l-15.78,-45.5zM187.7,190.69v7.34h-18v12.19h21.13v7.53h-30.5v-45.5h30.44v7.59h-21.07v10.85z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8YoutubeLive);
export default __webpack_public_path__ + "static/media/icons8-youtube-live.04ac9c8ea6aa4cdc93a89787bffa3928.svg";
export { ForwardRef as ReactComponent };